// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
  display: flex;
  flex: 1 auto;
  height: 100%;
}

.loading-ring {
  width: 32px;
  height: 32px;
}

.loading-text {
  margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/core/loader/loader.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AACA;EACE,YAAA;AAEF","sourcesContent":[".loading-container {\r\n  display: flex;\r\n  flex: 1 auto;\r\n  height: 100%;\r\n}\r\n\r\n.loading-ring {\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n.loading-text {\r\n  margin: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
